import React, { useState } from 'react';
import * as Icon from 'react-feather';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem }  from 'reactstrap';
import { ConfirmDeleteBusinessSupportNcrModal } from './ConfirmDeleteModal';
import { Can } from '../RBAC/Can';
import { BusinessSupportNcrService } from '../../services/BusinessSupportNcrService';
import moment from 'moment';
import { PdfActionItem } from '../FormComponents/Pdf/PdfActionItem';
import { PdfTable } from '../FormComponents/Pdf/PdfTable';

export const BusinessSupportNcrActionsButton = props => {
    const [state, setState] = useState({
        dropdownOpen: false,
        isConfirmDeleteModalOpen: false
    });

    const toggle = () => {
        setState((prevState) => ({
            ...prevState,
            dropdownOpen: !prevState.dropdownOpen
        }));
    };

    const toggleConfirmDeleteModal = () => {
        setState((prevState) => ({
            ...prevState,
            isConfirmDeleteModalOpen: !prevState.isConfirmDeleteModalOpen
        }));        
    };

    const handleDeleteConfirmed = (entity, e) => {
        props.handleDelete(entity, e);
    };

    const formTitle = "Business Support NCR";
    const [formService] = useState(new BusinessSupportNcrService());
    const form = props.businessSupportNcr;
    const formId = form.formId * 1;

    return (
        <>
            <div className="float-right">
                <ButtonDropdown direction="left" isOpen={state.dropdownOpen} toggle={toggle} size="sm">
                    <DropdownToggle caret color="primary" size="sm">Actions</DropdownToggle>
                    <DropdownMenu>
                        <DropdownItem onClick={(e) => props.handleView(props.businessSupportNcr, e)}> <Icon.FileText className="feather" />&nbsp; View</DropdownItem>
                        <DropdownItem divider />
                        
                        <PdfActionItem
                            formId={formId}
                            formService={formService}
                            title={formTitle}
                status={form.status}
                            logNo={form.ncrLogNo}
                            summary={
                                <>
                                    <PdfTable
                                        headers={["NCR Log No", "Job Planned By", "Date Job Planned"]}
                                        cells={[form.ncrLogNo, form.jobPlanner, form.dateJobPlanned != null ? moment(form.dateJobPlanned).format('DD/MM/YYYY') : "N/A"]}
                                    />
                                    <PdfTable
                                        headers={["Description of Issue"]}
                                        cells={[form.description]}
                                    />
                                </>
                            }
                            jobDetails={
                                <PdfTable
                                    headers={["Customer", "SKU", "Work Ticket / Batch No", "Quantity"]}
                                    cells={[form.customer !== undefined ? form.customer.name : "N/A", form.stockCode, form.workTicketNo, form.quantity]}
                                />
                            }
                        />
                        
                        <Can
                            perform="forms:delete"
                            yes={() => (
                                <>
                                    <DropdownItem divider />
                                    <DropdownItem onClick={() => toggleConfirmDeleteModal()}> <Icon.Trash2 className="feather" />&nbsp; Delete</DropdownItem>
                                </>
                            )}
                        />  
                    </DropdownMenu>
                </ButtonDropdown>
            </div>

            <ConfirmDeleteBusinessSupportNcrModal 
                isOpen={state.isConfirmDeleteModalOpen}
                toggle={toggleConfirmDeleteModal} 
                handleConfirm={handleDeleteConfirmed}
                businessSupportNcr={props.businessSupportNcr}
            />
        </>
    );
}

